import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { request } from '../../axios';
import type { PatientDto } from '../model';

export interface SyncContactVariables {
    patientId: string;
    referenceType: string;
}

export const syncContact = (patientId: string, referenceType: string, signal?: AbortSignal) => {
    return request<PatientDto>({
        url: `/api/patients/${patientId}/sync-contact`,
        method: 'POST',
        params: {
            referenceType,
        },
        signal,
    });
};

export const useSyncContactMutation = (
    options?: UseMutationOptions<PatientDto, Error, SyncContactVariables>,
) => {
    return useMutation<PatientDto, Error, SyncContactVariables>({
        mutationFn: ({ patientId, referenceType }) => syncContact(patientId, referenceType),
        ...options,
    });
};
